// extracted by mini-css-extract-plugin
export default {"modal":"ModalSetting_modal__9gqmh","showModal":"ModalSetting_showModal__0CglG","outer":"ModalSetting_outer__rDEXH","close":"ModalSetting_close__sFVlP"};